<template>
    <transition name="fade" ref="popup">
        <div class="popup-modal " v-if="visible">
            <div class="window">
                <div class="relative w-full">
                    <div class="h-screen w-full  animated fadeIn justify-center items-center faster fixed left-0 top-0 flex  inset-0 z-0 outline-none focus:outline-none"
                        id="modal-id">
                        <div class="absolute opacity-80 inset-0 z-0"></div>
                        <div class="relative mx-auto my-auto w-auto rounded-lg shadow-lg bg-white min-w-700-px">
                            <!--content-->
                            <div class="flex items-start justify-between p-5 rounded-t">
                                <h3 class="text-xl font-semibold">
                                    History of Grade Result ({{ subname }})
                                </h3>
                            </div>
                            <div class="flex-auto w-full overflow-x-hidden text-center text-sm max-h-500-px min-h-500-px">
                                <table class="items-center w-full bg-transparent border-collapse">
                                    <thead class="sticky top-0">
                                        <tr>
                                            <th
                                                class="px-6 align-middle border border-solid py-3 text-sm border-l-0 border-r-0 whitespace-nowrap font-semibold text-white" style="background-color: #6187B8;">
                                                No.
                                            </th>
                                            <th
                                                class="px-6 align-middle border border-solid py-3 text-sm border-l-0 border-r-0 whitespace-nowrap font-semibold text-white" style="background-color: #6187B8;">
                                                Student ID
                                            </th>
                                            <th
                                                class="px-6 align-middle border border-solid py-3 text-sm border-l-0 border-r-0 whitespace-nowrap font-semibold text-white" style="background-color: #6187B8;">
                                                Grade #1
                                            </th>
                                            <th
                                                class="px-6 align-middle border border-solid py-3 text-sm border-l-0 border-r-0 whitespace-nowrap font-semibold text-white" style="background-color: #6187B8;">
                                                Grade #2
                                            </th>
                                            <th
                                                class="px-6 align-middle border border-solid py-3 text-sm border-l-0 border-r-0 whitespace-nowrap font-semibold text-white" style="background-color: #6187B8;">
                                                Grade #3
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="history_arr.length === 0">
                                            <td colspan="5" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                                        </tr>
                                        <tr v-for="(history, index) in history_arr" :key="index">
                                            <td
                                                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm whitespace-nowrap p-4">
                                                {{ history.num }}
                                            </td>
                                            <td
                                                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm whitespace-nowrap p-4">
                                                {{ history.student_id }}
                                            </td>
                                            <td
                                                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm whitespace-nowrap p-4 text-center font-semibold">
                                                {{ history.grade }}
                                            </td>
                                            <td
                                                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm whitespace-nowrap p-4 text-center font-semibold"
                                                :class="{ 'bg-red-200': history.grade_edit === 'X' || history.grade_edit === 'I' }">
                                                {{ history.grade_edit }}
                                            </td>
                                            <td
                                                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm whitespace-nowrap p-4 text-center font-semibold">
                                                {{ history.grade_edit_end }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div
                                class="flex items-center h-70-px justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                                <button
                                    class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button" v-on:click="_cancel()">
                                    Close
                                </button>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </transition>
</template>
  
<script>
import api from './../../services/student_services';
export default {
    name: 'ModalDetailGrade',
    data() {
        return {
            visible: false,
            mid: undefined,
            status: undefined,
            subname: undefined,
            okButton: undefined,
            cancelButton: 'Close',
            history_arr: [],
            data_id: {
                "mid": '',
                "status": '',
            }
        };
    },
    methods: {
        async showAlert(id = {}) {
            this.visible = true
            this.mid = id.mid //ไว้ส่งค่าจากหน้าหลัก
            this.status = id.status //ไว้ส่งค่าจากหน้าหลัก
            this.subname = id.subname //ไว้ส่งค่าจากหน้าหลัก
            this.data_id = {
                "mid": this.mid,
                "status": this.status
            }
            api.smartgrade_history(this.data_id).then(async (result) => {
                // console.log(result.data);
                this.history_arr = result.data;
            });
        },
        _cancel() {
            this.visible = false
        },
    }
};
</script>
<style scoped>
/* css class for the transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.popup-modal {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    z-index: 1;
}

.window {
    background: #fff;
    border-radius: 25px;
    box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2);
    max-width: auto;
    margin-left: auto;
    margin-right: auto;
    padding: 1rem;
}</style>